import React, {FunctionComponent} from 'react';

import './App.scss';
import Wizard from './components/wizard/Wizard';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import Api from "./Api";

type AppParams = {
    action: string | null,
    userId: string | null
}

const App: FunctionComponent<AppParams> = ({action, userId}: AppParams) => {
    const [loading, setLoading] = React.useState(true);
    const [message, setMessage] = React.useState("Einen kleinen Moment bitte....");

    React.useEffect(() => {
        const abortController = new AbortController();
        if (userId !== null) {
            if (action === 'double-opt-in') {
                Api.doubleOptIn(userId, abortController.signal).then(() => {
                    setMessage("Ihr Abonnement wurde erfolgreich eingerichtet.");
                }).catch(() => {
                    setMessage("Es tut uns leid. Bei der Einrichtung ihres Abonnements ist ein Fehler aufgetreten. Bitte klicken Sie später erneut auf den Link aus der Nachricht um das Abonnement zu aktivieren.");
                }).finally(() => setLoading(false));
            } else if (action === 'opt-out') {
                Api.optOut(userId, abortController.signal).then(() => {
                    setMessage("Ihr Abonnement wurde erfolgreich beendet.");
                }).catch(() => {
                    setMessage("Es tut uns leid. Ihr konnte nicht beendet werden. Bitte klicken Sie später erneut auf den Link um Ihr Abonnement zu beenden.");
                }).finally(() => setLoading(false));
            }
        }
        return () => {
            abortController.abort();
        }
        // eslint-disable-next-line
    },  [])

    if (['double-opt-in', 'opt-out'].indexOf(action || '') > -1 && userId != null) {

        return <div className="msc-anmeldung__app msc-anmeldung__app__action">
            {loading ? <div className="msc-anmeldung__loading">
                <FontAwesomeIcon icon={faSpinner} pulse={true}/>
            </div> : <></>}
            <p>{message}</p>
        </div>;
    }
    return <div className="msc-anmeldung__app">
        <Wizard />
    </div>;
}

export default App;
